import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import BuildHealthSelectorComponent
  from './../Components/BuildHealthSelectorComponent.jsx';
import { setBuildHealthPageInfo } from './../actions';
import { buildHealth as buildHealthSelector } from '../selectors';
import { getBuildHealthInfo } from './../reducers';

export class BuildHealthSelectorContainer extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    builds: PropTypes.array,
    buildHealthSelectorInitialValues: PropTypes.object,
    buildHealthPageInfo: PropTypes.object
  };

  componentDidMount()
  {
    this.props.onSubmit(this.props.buildHealthSelectorInitialValues);
  }
  componentDidUpdate()
  {
    if (this.props.buildHealthSelectorInitialValues.buildNumber &&
      this.props.buildHealthSelectorInitialValues.buildNumber !== 0)
    {
      this.props.onSubmit(this.props.buildHealthSelectorInitialValues);
    }
  }

  render() {
    return this.props.buildHealthPageInfo.buildNumber === 0 ?
      null : (
        <BuildHealthSelectorComponent
          {...this.props}
        />
      );
  }
}

export const mapStateToProps = (state) => {
  const props =
   {
     builds: buildHealthSelector.getBuildHealthPageBuilds(state),
     buildHealthSelectorInitialValues: buildHealthSelector.
       getBuildHealthSelectorInitialValues(state),
     buildHealthPageInfo: getBuildHealthInfo(state)
   };
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: (buildHealthPageInfo) => {
    dispatch(setBuildHealthPageInfo(buildHealthPageInfo));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildHealthSelectorContainer);


// WEBPACK FOOTER //
// src/Containers/BuildHealthSelectorContainer.jsx